import ApiService from '@/common/api/api.service';

const urlBase = 'Titulo/contas-receber';
import helpers from '@/common/utils/helpers';

const ContaReceberService = {
  async buscarQuantidadeFiltro(params) {
    let { data } = await ApiService.get(
      `${urlBase}/gerenciar-boletos/obter-quantidade-por-filtro`,
      { params }
    );
    return data.data;
  },
  async bloquearPortalAluno(params) {
    let result = await ApiService.patch(
      `${urlBase}/gerenciar-boletos/bloquear-portal?DataFim=${params.dataFim}&DataInicio=${params.dataInicio}&MatriculaId=${params.dataVencimentoInicio}`
    );
    return result;
  },
  async liberarPortalAluno(params) {
    let result = await ApiService.patch(
      `${urlBase}/gerenciar-boletos/liberar-portal?DataFim=${params.dataFim}&DataInicio=${params.dataInicio}&MatriculaId=${params.dataVencimentoInicio}`,
      { params }
    );
    return result;
  },
  async criar(form) {
    let result = await ApiService.post(`${urlBase}/criar`, form);
    return result;
  },
  async buscarMatriculas() {
    let { data } = await ApiService.get(
      `Matricula?TamanhoDaPagina=10&NumeroDaPagina=1`
    );
    return data.data;
  },
  async buscarContrato() {
    let { data } = await ApiService.get('Contrato/obter-todos');
    return data.data;
  },
  async buscarContratoDadosBasicos() {
    let { data } = await ApiService.get('Contrato/obter-todos-basico');
    return data.data;
  },
  async buscarConta(paginacao) {
    let { data } = await ApiService.get(`Conta`, { params: paginacao });
    return data.data;
  },
  async buscarDesconto(paginacao) {
    let { data } = await ApiService.get(`Desconto`, { params: paginacao });
    return data.data;
  },
  async buscarContasReceber(paginacao, filtro, campoOrdenado, ordem) {
    let { data } = await ApiService.get(`${urlBase}/obter-por-filtro`, {
      params: {
        ...paginacao,
        ...filtro,
        CampoOrdenado: campoOrdenado,
        OrdenacaoAscendente: ordem,
      },
    });
    data.data.itens = data.data.itens.map((row) => ({
      ...row,
      text: row.nome,
      value: row.id,
      _rowVariant: this.corLinhaContasReceber(row),
    }));

    return data;
  },
  async listarContasReceberPaginado(paginacao, filtro, campoOrdenado, ordem) {
    let { data } = await ApiService.get(`${urlBase}/por-filtro-paginado`, {
      params: {
        ...paginacao,
        ...filtro,
        CampoOrdenado: campoOrdenado,
        OrdenacaoAscendente: ordem,
      },
    });
    data.data.itens = data.data.itens.flatMap((aluno) => [
      { nomeAluno: aluno.nomeAluno, numeroMatricula: aluno.numeroMatricula },
      ...aluno.dadosDoAlunoAgrupado.map((financeiroAluno) => ({
        ...financeiroAluno,
        _rowVariant: this.corLinhaContasReceber(financeiroAluno),
      })),
    ]);

    return data;
  },
  corLinhaContasReceber(row) {
    if (row.statusPagamentoDescricao == 'Liquidado') return 'success';
    if (row.statusPagamentoDescricao == 'Cancelado') return 'danger';
  },
  async buscarStatusPagamento() {
    let { data } = await ApiService.get(`enumeradores/status-pagamento`);
    return data.data;
  },
  async buscarHistoricoContaReceber() {
    let { data } = await ApiService.get(`HistoricoLancamento/contas-a-receber`);
    return data.data;
  },
  async baixarTitulo(form, ehLista) {
    const url = ehLista
      ? 'Titulo/contas-receber/baixar-lista'
      : 'Titulo/contas-receber/baixar';
    let result = await ApiService.patch(url, form);
    return result;
  },
  async estornar(id) {
    let { data } = await ApiService.patch(`Titulo/contas-receber/estornar`, {
      id,
    });
    return data.data;
  },
  async calcularJuros(id) {
    const resultadoIdsFormatadosParametro = id
      .map(({ id, dataPagamento }) => {
        return `DataPagamento=${dataPagamento}&ids=${id}&`;
      })
      .join('');

    let { data } = await ApiService.get(
      `Titulo/contas-receber/calcular-juros?${resultadoIdsFormatadosParametro}`
    );
    return data.data;
  },
  async buscarListaDeContasReceber(id) {
    const resultadoIdsFormatadosParametro = id
      .map((id) => {
        return `ids=${id}&`;
      })
      .join('');

    let { data } = await ApiService.get(
      `Titulo/contas-receber/busca-por-ids?${resultadoIdsFormatadosParametro}`
    );
    return data.data;
  },
  async atualizarDesconto(form) {
    let { data } = await ApiService.patch(
      `Titulo/contas-receber/atualizar-desconto`,
      form
    );
    return data.data;
  },
  async removerDesconto(form) {
    let { data } = await ApiService.patch(
      'Titulo/contas-receber/remover-desconto',
      form
    );
    return data;
  },
  async liberarPortal(form) {
    let { data } = await ApiService.patch(
      `Titulo/contas-receber/liberar-portal`,
      form
    );
    return data;
  },
  async bloquearPortal(form) {
    let { data } = await ApiService.patch(
      `Titulo/contas-receber/bloquear-portal`,
      form
    );
    return data;
  },
  async cancelarTitulo(form) {
    let { data } = await ApiService.patch(
      `Titulo/contas-receber/cancelar-titulo`,
      form
    );
    return data;
  },
  async cancelarBoleto(ids) {
    let { data } = await ApiService.patch(
      `Titulo/contas-receber/cancelar-boleto`,
      ids
    );
    return data;
  },
  // RELATORIOS
  async imprimirCartaCobranca(filtro) {
    let { data } = await ApiService.get(`${urlBase}/imprimir-carta-cobranca`, {
      params: filtro,
    });
    return data;
  },
  async imprimirInadimplencia(filtro) {
    let { data } = await ApiService.get(`${urlBase}/imprimir-inadimplencia`, {
      params: filtro,
    });
    return data;
  },
  async imprimirRecibo(form) {
    let { data } = await ApiService.post(
      `LancamentoCaixa/imprimir-recibo`,
      form
    );
    return data;
  },
  async obterPorFiltroLista(filtro) {
    let { data } = await ApiService.post(
      `${urlBase}/obter-por-filtro-lista`,
      null,
      { params: filtro }
    );
    return data;
  },
  async gerarRelatorioAnaliseRetroativa(filtro) {
    let { data } = await ApiService.get(
      `${urlBase}/imprimir-analise-retroativa`,
      { params: filtro }
    );
    return data;
  },
  async gerarExtrato(filtro, ordenarPorData) {
    let { data } = await ApiService.get(`${urlBase}/imprimir-extrato`, {
      params: helpers.normalizarFiltros({ ...filtro, ordenarPorData }),
    });
    return data;
  },
};

export default ContaReceberService;
